import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { JhiEventManager } from 'ng-jhipster';

import { QueueService } from '../../../../../services';
import { Queue } from '../../../../../models';
import { QUEUE_LIST_MODIFICATION } from '../../../../../shared/constants';

@Component({
    selector: 'qms-queue-navigation-menu-element',
    templateUrl: './queue-navigation-menu-element.component.html'
})
export class QueueNavigationMenuElementComponent implements OnInit, OnDestroy {

    @Input()
    public queue: Queue;

    @Input()
    public onlyCategoryQueues: boolean;

    public children: Observable<Array<Queue>>;

    @Input()
    public selectedElement: any;

    @Input()
    public active: boolean;

    private queueSubscription: Subscription;

    constructor(private queueService: QueueService,
                private eventManager: JhiEventManager) {
        this.children = new Observable<Array<Queue>>();
    }

    ngOnInit() {
        this.loadChildren();
        this.registerChangeInQueues();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.queueSubscription);
    }

    public isSelected() {
        return this.active
            && (this.selectedElement !== null && this.selectedElement !== undefined)
            && ((this.selectedElement instanceof Queue)
                && (this.selectedElement.id) === (this.queue.id));
    }

    public loadChildren() {
        this.children = this.queueService.findChildren(this.queue.id);
    }

    private registerChangeInQueues() {
        this.queueSubscription = this.eventManager.subscribe(QUEUE_LIST_MODIFICATION, (response) => {
            this.loadChildren();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/management-navigation-menu/queues-management-navigation-menu/queue-navigation-menu-element/queue-navigation-menu-element.component.ts